import * as React from 'react';

import PointerChevronDown24 from './PointerChevronDown24';

export const pointerChevronDown24 = () => <PointerChevronDown24 />;

export default {
    title: 'Icon/Fill/PointerChevronDown24',
    component: PointerChevronDown24,
    parameters: {
        notes: "`import PointerChevronDown24 from 'box-ui-elements/es/icon/fill/PointerChevronDown24';`",
    },
};
